/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Public_SubtitleInputs */

const cs_import_public_subtitle = /** @type {(inputs: Import_Public_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložte IT token od administrátora organizace a nahrajte export.`)
};

const en_import_public_subtitle = /** @type {(inputs: Import_Public_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the IT token from your organization admin, then upload the dump.`)
};

/**
* | output |
* | --- |
* | "Paste the IT token from your organization admin, then upload the dump." |
*
* @param {Import_Public_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_public_subtitle = /** @type {((inputs?: Import_Public_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Public_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_public_subtitle(inputs)
	return cs_import_public_subtitle(inputs)
});